// ======================================================================
// File Name       : ContentSelectionForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Col, Table } from 'react-bootstrap';
import PaginationCustom from '../Pagination';

class ContentLinkContentSelectionForm extends React.Component {
  render() {
    const props = this.props;
    const { bySecernId, allSecernIds, recordNum } = props.contents;
    const { startPosition } = props;
    return (
      <Col sm={12}>
        <PaginationCustom
          className="float-end margin-top-clear"
          recordNum={recordNum}
          handlePageSelect={props.handlePageChange}
          startPosition={startPosition}
        />
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th width="70">選択</th>
              <th>コンテンツ識別ID</th>
              <th>コンテンツ名</th>
            </tr>
          </thead>
          <tbody>
            {allSecernIds.map((contentSecernIdMix, index) => {
              const { contentSecernId, contentName } = bySecernId[contentSecernIdMix];
              return (
                <tr key={index}>
                  <td className="text-center">
                    <Field
                      name="contentSecernId"
                      component="input"
                      type="radio"
                      value={contentSecernIdMix}
                      id={contentSecernIdMix}
                    />
                  </td>
                  <td style={{ padding: "0px" }}>
                    <label
                      className="form-label"
                      htmlFor={contentSecernIdMix}
                      className="cursor_pointer displayBlock"
                      style={{ padding: "8px" }}
                    >
                      {contentSecernId}
                    </label>
                  </td>
                  <td style={{ padding: "0px" }}>
                    <label
                      className="form-label"
                      htmlFor={contentSecernIdMix}
                      className="cursor_pointer displayBlock"
                      style={{ padding: "8px" }}
                    >
                      {contentName}
                    </label>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Col>
    );
  }
}

ContentLinkContentSelectionForm.propTypes = {
  contents: PropTypes.shape({}),
};

ContentLinkContentSelectionForm.defaultProps = {
  contents: {},
};

const mapStateToProps = (state, props) => {
  const { contents } = state.content;
  return {
    ...{ contents },
    initialValues: {
      contentSecernId: state.item.edittingItem.contentInfo.contentSecernId,
    },
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'contentLinkContentSelectionForm',
    enableReinitialize: true,
    touchOnChange: true,
  })(ContentLinkContentSelectionForm),
);
